import { render, staticRenderFns } from "./administrationSales.vue?vue&type=template&id=1c7d6039&scoped=true&"
import script from "./administrationSales.vue?vue&type=script&lang=js&"
export * from "./administrationSales.vue?vue&type=script&lang=js&"
import style0 from "./administrationSales.vue?vue&type=style&index=0&id=1c7d6039&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d6039",
  null
  
)

export default component.exports